<div *ngIf="!isEditUser" class="import-user col-12" [ngStyle]="contentStyle">
  <div [ngStyle]="borderStyle">
    <div (click)="showHideImportUser()" [ngStyle]="colorTextAlignStyle" class="title cursor-pointer">
      <i [class.right]="!isShowUser" [class.down]="isShowUser" class="arrow"></i>
      Import User
    </div>
    <div [class.hide]="!isShowUser" class="row col-12 mt-2 text-center">
      <div class="col-5">
        <label [ngStyle]="colorTextAlignStyle" for="fname">First Name</label>
        <finx-input
          [(ngModel)]="firstName"
          style="width: 100%"
          [ngModelOptions]="{ standalone: true }"
          class="country-dropdown no-padding"
          [textColor]="colorTextAlignStyle"
        >
        </finx-input>
      </div>

      <div class="col-5">
        <label [ngStyle]="colorTextAlignStyle" for="fname">Last Name</label>
        <finx-input
          [(ngModel)]="lastName"
          style="width: 100%"
          [ngModelOptions]="{ standalone: true }"
          class="country-dropdown no-padding"
          [textColor]="colorTextAlignStyle"
        >
        </finx-input>
      </div>
      <div class="col-2 seacrh-main">
        <finx-button
          labeltext=""
          [disabled]="!firstName || !lastName || isImportUserApiProcess"
          class="search-import-user-btn pull-right"
          (click)="getImportUsers()"
        ></finx-button>
        <img
          alt="img-search"
          class="img-search"
          (click)="getImportUsers()"
          src="assets/images/search-import-user-icon.svg"
        />
      </div>
    </div>

    <div
      *ngIf="importusers?.length"
      [class.hide]="!isShowUser"
      class="matched-user-list-main row col-12 mt-2 text-center"
    >
      <table aria-describedby="matche-suer" class="matched-user-list">
        <thead>
          <tr>
            <th [ngStyle]="colorTextAlignStyle">USERNAME</th>
            <th [ngStyle]="colorTextAlignStyle">PHONE NUMBER</th>
            <th [ngStyle]="colorTextAlignStyle">EMAIL</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let importuser of importusers">
            <td
              [ngStyle]="colorTextAlignStyle"
              class="activetd"
              [title]="importuser.email"
              (click)="showImportUserData(importuser)"
            >
              <finx-input name="slecteduser" type="radio" class="selectuser-radion"></finx-input>

              {{ importuser.email }}
            </td>
            <td>{{ importuser.phone }}</td>
            <td>{{ importuser.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row col-12 show-entity">
      <p *ngIf="importusers?.length && isShowUser && isImportUserApiCalled">
        {{ importusers.length }} results for “
        {{ firstName + ' ' + lastName }}
      </p>
      <p *ngIf="!importusers && isShowUser && isImportUserApiCalled" class="loader-text">No records found</p>
    </div>
  </div>
</div>
